import { GsapMarquee } from '../../ui/GsapMarquee/GsapMarquee';
import logo from '../../../assets/logo.jpeg';
import { Link } from 'react-router-dom';
import './Footer.css';

const IgIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const LiIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="3" y="3" width="18" height="18" rx="3" />
    <path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4M12 10v7" />
  </svg>
);

const YtIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M3 8.5a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-7Z" />
    <path d="m10 9 5 3-5 3V9Z" fill="currentColor" stroke="none" />
  </svg>
);

const cols = [
  {
    title: 'Studio',
    links: ['About', 'Manifesto', 'Press', 'Careers'],
  },
  {
    title: 'Practice',
    links: ['Corporate', 'Social', 'Cultural', 'Entertainment', 'Sporting'],
  },
  {
    title: 'Contact',
    links: ['luminarentertainments123@gmail.com', '+91 81290 77431', 'Aluva, Kerala'],
  },
];

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__marquee">
        <GsapMarquee speed={50}>
          {['Corporate', 'Social', 'Cultural', 'Sporting', 'Academic', 'Religious', 'Entertainment', 'Political'].map(
            (t) => (
              <span key={t} className="footer__marquee-item">
                <span className="footer__marquee-star">✦</span>
                {t}
              </span>
            )
          )}
        </GsapMarquee>
      </div>

      <div className="container footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <img src={logo} alt="Luminar" className="footer__logo" />
            <div>
              <div className="footer__name">Luminar Entertainments</div>
              <div className="footer__tag">Spectacle, staged with discipline.</div>
            </div>
          </div>

          <div className="footer__cta">
            <div className="footer__cta-label">Let's build something inevitable</div>
            <a href="mailto:luminarentertainments123@gmail.com" className="footer__cta-mail">
              luminarentertainments123@gmail.com
            </a>
          </div>
        </div>

        <div className="footer__grid">
          {cols.map((c) => (
            <div key={c.title} className="footer__col">
              <div className="footer__col-title">{c.title}</div>
              <ul>
                {c.links.map((l) => (
                  <li key={l}>{l}</li>
                ))}
              </ul>
            </div>
          ))}

          <div className="footer__col">
            <div className="footer__col-title">Follow</div>
            <div className="footer__social">
              <a href="https://www.instagram.com/luminarentertaiments?igsh=bmE2OGE3Z3U4MW04" target="_blank" rel="noreferrer" aria-label="Instagram"><IgIcon /></a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"><LiIcon /></a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="Youtube"><YtIcon /></a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <div>© 2026 Luminar Entertainments. All rights reserved.</div>
          <div className="footer__legal">
            <Link to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</Link>
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</Link>
            <Link to="/privacy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
            <Link to="/terms" onClick={() => window.scrollTo(0, 0)}>Terms and Conditions</Link>
            <Link to="/refund" onClick={() => window.scrollTo(0, 0)}>Refund/Cancellation Policy</Link>
            <Link to="/login" onClick={() => window.scrollTo(0, 0)}>Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
